<template>
  <div class="wh100">
    <div class="top-bg"></div>
    <div class="top">
      <div class="tabbar-container2">
        <div class="tabbar-title">山东矿机培训考试</div>
        <div v-show="userView" class="tabbar-user">
          {{ nickname }}
          <van-image style="padding-left: 0.5rem" width="2rem" height="2rem" round fit="contain" :src="headimgurl" />
        </div>
      </div>
      <div class="sdkj-view">
        <!-- <van-search
          v-model="value"
          shape="round"
          show-action
          placeholder="搜索你感兴趣的内容"
        >
          <template #action>
            <van-button style="width: 55px" size="small" round type="info"
              >搜索</van-button
            >
          </template>
        </van-search> -->

        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <van-image width="100%" :src="banner" />
            </div>
            <div class="swiper-slide">
              <van-image width="100%" :src="banner" />
            </div>
            <div class="swiper-slide">
              <van-image width="100%" :src="banner" />
            </div>
          </div>
        </div>
      </div>
      <div class="sdkj-view">
        <div class="px-view">
          <van-icon style="margin-right: 5px" color="#0181fe" name="fire" />
          <span style="font-weight: bold">培训、考试</span>
          <span style="font-size: 0.9rem; color: #cbcbcb; margin-left: 10px">选择班级学习</span>
        </div>
        <van-grid style="margin-top: 10px" :border="false" :gutter="10" :column-num="3">
          <van-grid-item v-for="(item, index) in itemList" @click="gridClick(item)" :key="index">
            <div class="grid-item">
              <van-image width="55px" height="55px" fit="contain" :src="item.img" />
              <div class="grid-text">{{ item.tab }}</div>
            </div>
          </van-grid-item>
        </van-grid>
      </div>

      <div class="sdkj-view">
        <div class="px-view">
          <van-icon style="margin-right: 5px" color="#0181fe" name="fire" />
          <span style="font-weight: bold">快捷入口</span>
          <van-icon @click="notify()" style="margin-left: 10px" color="#0181fe" name="question-o" />
          <span style="font-size: 0.9rem; color: #cbcbcb; margin-left: 10px">根据员工类别的快速入口</span>
        </div>
        <van-grid style="margin-top: 10px" :border="false" :gutter="10" :column-num="3">
          <van-grid-item v-for="(item, index) in itemList2" @click="gridClick(item)" :key="index">
            <div class="grid-item">
              <van-image width="55px" height="55px" fit="contain" :src="item.img" />
              <div class="grid-text">{{ item.tab }}</div>
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>

    <van-popup v-model="showVideoList" position="right" :lock-scroll="false" :style="{ width: '100%', height: '100%' }">
      <video-list v-if="showVideoList" @fatherMethod2="Back2" @videoDone="videoDone" :QuesID="QuesID" :name="name" @listBack="ListBack" />
    </van-popup>

    <van-popup v-model="showQues" position="bottom" round :lock-scroll="false">
      <van-cascader
        v-model="QuesID"
        title="请选择科目"
        :options="QueData"
        active-color="#1989fa"
        :field-names="{
          text: 'SubjectName',
          value: 'SubjectID',
          children: 'children',
        }"
        @close="showQues = false"
        @finish="onFinish"
      />
    </van-popup>

    <van-popup v-model="showSubject" position="bottom" round :lock-scroll="false">
      <van-cascader
        v-model="QuesID"
        title="请选择科目"
        :options="kjData"
        active-color="#1989fa"
        :field-names="{
          text: 'SubjectName',
          value: 'SubjectID',
          children: 'children',
        }"
        @close="showSubject = false"
        @finish="onSubjectFinish"
      />
    </van-popup>

    <van-popup v-model="showKS" position="right" :lock-scroll="false" :style="{ width: '100%', height: '100%' }">
      <special v-if="showKS" />
    </van-popup>

    <van-overlay :show="addLoading" :custom-style="{ background: 'rgba(0,0,0,0.2)' }">
      <van-loading style="position: absolute; top: calc(50% - 25px); left: calc(50% - 30px)" size="50px" color="#0094ff" vertical text-color="#0094ff">加载中</van-loading>
    </van-overlay>
  </div>
</template>

<script>
// import wx from './wx.js'
import Utils from "../../utils/util.js";
import { Dialog } from "vant";
import { mapState } from "vuex";
import special from "./special.vue";
import videoList from "./videoList.vue";
import "swiper/dist/js/swiper";
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";
export default {
  name: "appMenu",
  components: { videoList, special },
  computed: {
    ...mapState({
      mainRoutes(state) {
        const arrGroup = this.$arrayGroup(state.permission.routes, "type");
        const re = this.$getTypeName(arrGroup, "type", "1", {});
        if (re && re.data) {
          return re.data;
        } else {
          return [];
        }
      },
    }),
  },
  data() {
    return {
      addLoading: false,
      ks: [],
      showKS: false,
      // 搜索文本
      value: null,
      // 选择科目id
      QuesID: "",
      // 选择科目名字
      name: "",
      // 总科目树
      QueData: [],
      // 快捷进入科目/部门树
      kjData: [],
      // 学习列表
      showVideoList: false,

      // 当日观看历史
      videoHistory: [],

      // 展开选择科目。
      showQues: false,
      showSubject: false,

      // 首页用户头像
      headimgurl: "",
      // 首页用户微信名称
      nickname: "",
      // 是否显示用户肖像
      userView: false,

      banner: require("../../assets/icon/banner2.png"),
      mnks: require("../../assets/icon/icon_mnks.png"),
      zxlx: require("../../assets/icon/icon_zxlx.png"),

      // grid
      itemList: [
        {
          tab: "培训学习",
          img: require("../../assets/icon/zdykc.png"),
        },
        {
          tab: "考试",
          img: require("../../assets/icon/icon_ctj.png"),
        },
      ],
      // grid
      itemList2: [
        {
          tab: "快捷进入",
          img: require("../../assets/icon/icon_grfx.png"),
        },
      ],
    };
  },
  watch: {},
  created() {},
  async mounted() {
    const q = await this.$store.dispatch("api/GetFuntree");
    this.QueData = q.data;

    new Swiper(".swiper-container", {
      //mousewheel: true, //滚轮
      autoplay: {
        //自动开始
        delay: 5000, //时间间隔
        disableOnInteraction: false, //*手动操作轮播图后不会暂停*
      },
      loop: false, // 循环模式选项
    });

    if (localStorage.getItem("IdCard")) {
      this.addLoading = true;
      setTimeout(() => {
        this.addLoading = false;
      }, 20000);

      const student = await this.$store.dispatch("api/GetSutentById", {
        IdCard: localStorage.getItem("IdCard"),
      });

      if (student.data && student.data.length > 0) {
        this.student = student.data[0];

        // TODO
        if (this.isDis()) {
          this.addLoading = false;
          return;
        }

        // 部门/科目查询
        const bm = await this.$store.dispatch("api/GetFunTree2", { SubjectID: this.student.SubjectIDSingle });
        this.kjData = bm.data;

        await this.KS();
      } else {
        Dialog.confirm({
          message: "信息完善未完善\n请去【我的-信息完善】中补全信息",
          showCancelButton: false,
          confirmButtonText: "去完善",
        }).then(() => {
          this.Back2();
        });
      }

      this.addLoading = false;
    }

    // if (localStorage.getItem("openid")) {
    //   this.userView = true;
    //   this.nickname = localStorage.getItem("nickname");
    //   this.headimgurl = localStorage.getItem("headimgurl");

    //   await this.KS();
    //   return;
    // } else {
    //   this.userView = false;
    // }

    // if (this.getUrlParam("code")) {
    //   localStorage.setItem("code", this.getUrlParam("code"));
    //   window.location.href =
    //     `https://` +
    //     this.$store.getters.appconfig.wxConfig.webUrl +
    //     `?version=${new Date().getTime()}`;
    //   return;
    // }

    // if (localStorage.getItem("code")) {
    //   this.$store
    //     .dispatch("api/getUserInfo", { code: localStorage.getItem("code") })
    //     .then((response) => {
    //       if (response.success) {
    //         localStorage.setItem("openid", response.data.OpenId);
    //         localStorage.setItem("headimgurl", response.data.HeadImageUrl);
    //         localStorage.setItem("nickname", response.data.Nickname);

    //         this.userView = true;
    //         this.nickname = localStorage.getItem("nickname");
    //         this.headimgurl = localStorage.getItem("headimgurl");
    //         this.KS();
    //         localStorage.setItem("code", "");
    //       } else {
    //         localStorage.setItem("code", "");
    //         this.$notify(response.message);
    //       }
    //     })
    //     .catch((error) => {
    //       localStorage.setItem("code", "");
    //       console.log(error);
    //     });
    // }
  },
  destroyed() {},
  methods: {
    notify() {
      this.$notify({ type: "success", message: "快捷进入，会根据员工的类别，快速选择自己培训学习的部门或者科目。例如您是一个XX部门的员工，点击快捷进入程序会自动帮您筛选所属的XX部门。", duration: 10000 });
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; //返回参数值
    },
    async KS() {
      if (localStorage.getItem("IdCard")) {
        const Graduation = await this.$store.dispatch("api/GetGraduationByIdCard", {
          IdCard: localStorage.getItem("IdCard"),
        });
        if (Graduation.data && Graduation.data.length > 0) {
          this.ks = Graduation.data;
          if (this.student.StudentType == "新员工") {
            //新员工逻辑
            let kpname = "";

            if (Graduation.data.find((a) => a.SubjectName === "公司级" && a.SZhuangTai != "及格")) {
              kpname = "gs";
            }
            if (Graduation.data.find((a) => a.SubjectName === "部门级" && a.SZhuangTai != "及格")) {
              kpname = "bm";
            }
            if (Graduation.data.find((a) => a.SubjectName === "班组级" && a.SZhuangTai != "及格")) {
              kpname = "bz";
            }

            if (!kpname) {
              return false;
            }

            let flagJson = {
              gs: "公司级",
              bm: "部门级",
              bz: "班组级",
            };
            Dialog.confirm({
              message: "您已完成" + flagJson[kpname] + "培训，可以开始" + flagJson[kpname] + "考试",
              showCancelButton: true,
              confirmButtonText: "去考试",
            })
              .then(() => {
                window.open("https://ks.sdkjjt.com:8071/TestManage/TestEntrance?kpname=" + kpname);
              })
              .catch(() => {});
          } else if (this.student.StudentType == "外来工作人员") {
            //外来工作人员工逻辑（通知后台，结业学时设定为1）
            let kpname = "";
            if (Graduation.data.find((a) => a.SubjectName === "外来工作人员" && a.SZhuangTai != "及格")) {
              kpname = "wlgzry";
            }
            if (!kpname) {
              return false;
            }
            let flagJson = {
              wlgzry: "外来工作人员",
            };
            Dialog.confirm({
              message: "您已完成" + flagJson[kpname] + "培训，可以开始" + flagJson[kpname] + "考试",
              showCancelButton: true,
              confirmButtonText: "去考试",
            })
              .then(() => {
                window.open("https://ks.sdkjjt.com:8071/TestManage/TestEntrance?kpname=" + kpname);
              })
              .catch(() => {});
          } else if (this.student.StudentType == "参观实习人员") {
            //参观实习人员逻辑（通知后台，结业学时设定为1）
            let kpname = "";
            if (Graduation.data.find((a) => a.SubjectName === "参观实习人员" && a.SZhuangTai != "及格")) {
              kpname = "cgsxry";
            }
            if (!kpname) {
              return false;
            }
            let flagJson = {
              cgsxry: "参观实习人员",
            };
            Dialog.confirm({
              message: "您已完成" + flagJson[kpname] + "培训，可以开始" + flagJson[kpname] + "考试",
              showCancelButton: true,
              confirmButtonText: "去考试",
            })
              .then(() => {
                window.open("https://ks.sdkjjt.com:8071/TestManage/TestEntrance?kpname=" + kpname);
              })
              .catch(() => {});
          }else {
            //考培分离逻辑
            Dialog.confirm({
              message: "您已经达到结业学时，可以考试",
              showCancelButton: true,
              confirmButtonText: "去考试",
            })
              .then(() => {
                window.open("https://ks.sdkjjt.com:8071/TestManage/TestEntrance");
              })
              .catch(() => {
                console.log(111, "取消");
              });
          }
        }
      }
    },
    async VideoHistory() {
      if (localStorage.getItem("IdCard")) {
        const videoHistory = await this.$store.dispatch("api/VideoHistory", {
          IdCard: localStorage.getItem("IdCard"),
          UPDATETIME: this.$getNowDate("yyyy-mm-dd hh:mm:ss"),
        });
        this.videoHistory = videoHistory.rows;
      }
    },
    // 是否登录
    isLogin() {
      if (localStorage.getItem("IdCard")) {
        return true;
      } else {
        Dialog.confirm({
          title: "您未登录，请先登录后使用模拟考试",
          showCancelButton: false,
          confirmButtonText: "去登录",
        }).then(() => {
          Utils.$emit("my");
        });
        return false;
      }
    },
    // 是否禁用
    isDis() {
      if (this.student.Status === 1) {
        return false;
      } else {
        Dialog.confirm({
          title: "请联系管理员开启权限",
          showCancelButton: false,
          confirmButtonText: "确认",
        });
        return true;
      }
    },

    // 是否信息完善
    async isMessage() {
      const student = await this.$store.dispatch("api/GetStudentByOpenId", {
        OpenId: localStorage.getItem("openid"),
      });

      if (student.data && student.data.length > 0 && student.data[0].IdCard) {
        localStorage.setItem("IdCard", student.data[0].IdCard);
        return true;
      } else {
        Dialog.confirm({
          message: "信息完善未完善\n请去【我的-信息完善】中补全信息",
          showCancelButton: false,
          confirmButtonText: "去完善",
        }).then(() => {
          this.Back2();
        });
        return false;
      }
    },
    async videoDone() {
      if (localStorage.getItem("IdCard")) {
        const Graduation = await this.$store.dispatch("api/GetGraduationByIdCard", {
          IdCard: localStorage.getItem("IdCard"),
        });
        if (Graduation.data && Graduation.data.length > 0) {
          this.ks = Graduation.data;
        }
      }
    },
    ListBack() {
      this.showVideoList = false;
    },
    Back2() {
      this.showVideoList = false;
      setTimeout(() => {
        Utils.$emit("my");
      }, 500);
    },
    gridClick(item) {
      switch (item.tab) {
        case "培训学习":
          if (this.isLogin() && !this.isDis()) {
            // if (await this.isMessage()) {
            // localStorage.setItem("IdCard", "370612199406103333");
            this.showQues = true;
            // }
          }
          break;
        case "快捷进入":
          if (this.isLogin() && !this.isDis()) {
            this.showSubject = true;
          }
          break;
        case "考试":
          if (this.isLogin() && !this.isDis()) {
            window.open("https://ks.sdkjjt.com:8071/TestManage/TestEntrance");
          }
          break;
      }
    },
    async onFinish(e) {
      // 新员工逻辑过滤
      if (this.student.StudentType == "新员工") {
        await this.VideoHistory();
        //针对三级培训，线上培训每日不得超过10学时s
        //1.将今日学习的学时统计出来
        let todayCourseHour = this.videoHistory.reduce((total, item) => {
          return total + parseFloat(item.VideoHour);
        }, 0);
        console.log("todayCourseHour", todayCourseHour);
        //2.判断今日总学时是否超过10个
        if (todayCourseHour > 10) {
          Dialog.confirm({
            message: "线上培训每日不得超过10学时",
            showCancelButton: false,
            confirmButtonText: "确定",
          });
          return false;
        }
        //针对三级培训，线上培训每日不得超过10学时e
        var SubjectName = e.selectedOptions[e.selectedOptions.length - 1].SubjectName;
        if (SubjectName == "部门级") {
          const a = this.ks.find((a) => a.SubjectName === "公司级" && a.SZhuangTai === "及格");
          if (!a) {
            Dialog.confirm({
              message: "公司级考试尚未及格",
              showCancelButton: false,
              confirmButtonText: "确定",
            });

            return;
          }
        }
        if (SubjectName == "班组级") {
          const a = this.ks.find((a) => a.SubjectName === "部门级" && a.SZhuangTai === "及格");
          if (!a) {
            Dialog.confirm({
              message: "部门级考试尚未及格",
              showCancelButton: false,
              confirmButtonText: "确定",
            });

            return;
          }
        }
      }
      var name = "";
      if (e.selectedOptions && e.selectedOptions.length > 0) {
        e.selectedOptions.forEach((a) => {
          if (name) {
            name = name + "-" + a.SubjectName;
          } else {
            name = a.SubjectName;
          }
        });
      }
      this.name = name;
      this.showQues = false;
      setTimeout(() => {
        this.showVideoList = true;
      }, 500);
    },
    async onSubjectFinish(e) {
      let selectedOptions = e.selectedOptions;
      let tabIndex = e.tabIndex;
      // 新员工逻辑过滤
      if (this.student.StudentType == "新员工") {
        await this.VideoHistory();
        //针对三级培训，线上培训每日不得超过10学时s
        //1.将今日学习的学时统计出来
        let todayCourseHour = this.videoHistory.reduce((total, item) => {
          return total + parseFloat(item.VideoHour);
        }, 0);
        console.log("todayCourseHour", todayCourseHour);
        //2.判断今日总学时是否超过10个
        if (todayCourseHour > 10) {
          Dialog.confirm({
            message: "线上培训每日不得超过10学时",
            showCancelButton: false,
            confirmButtonText: "确定",
          });
          return false;
        }
        //针对三级培训，线上培训每日不得超过10学时e
        var SubjectName = e.selectedOptions[e.selectedOptions.length - 1].SubjectName;
        if (SubjectName == "部门级") {
          const a = this.ks.find((a) => a.SubjectName === "公司级" && a.SZhuangTai === "及格");
          if (!a) {
            Dialog.confirm({
              message: "公司级考试尚未及格",
              showCancelButton: false,
              confirmButtonText: "确定",
            });

            return;
          }
        }
        if (SubjectName == "班组级") {
          const a = this.ks.find((a) => a.SubjectName === "部门级" && a.SZhuangTai === "及格");
          if (!a) {
            Dialog.confirm({
              message: "部门级考试尚未及格",
              showCancelButton: false,
              confirmButtonText: "确定",
            });

            return;
          }
        }
      }
      this.name = selectedOptions[tabIndex].SubjectName;
      this.showSubject = false;
      setTimeout(() => {
        this.showVideoList = true;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  width: 100%;
  padding: 0 13px;
  box-sizing: border-box;
  position: relative;
}

.top-bg {
  position: fixed;
  top: 0;
  height: 200px;
  background: #0181fe;
  width: 100%;
  z-index: 0;
}

.sdkj-view {
  margin-top: 15px;
  z-index: 999 !important;
  width: 100%;
  padding: 13px;
  border-radius: 10px;
  box-sizing: border-box;
  background: #fefefe;
}

.px-view {
  font-size: 1.05rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #333333;
}

.ks-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tabbar-container2 {
  width: 100%;
  color: white;
  z-index: 1 !important;
  height: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .tabbar-title {
    z-index: 1;
    font-weight: bold;
    font-size: 1.1rem;
  }

  .tabbar-user {
    z-index: 1;
    font-size: 0.8rem;
    display: flex;
    flex-direction: row;
    align-items: center;

    .tabbar-userimg {
      width: 20px;
      height: 20px;
    }
  }
}

.grid-item {
  width: 100%;
  height: 80px;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;

  .grid-text {
    color: #666666;
    margin-top: 5px;
    font-size: 0.9rem;
  }
}

.tabbar-container {
  width: 100%;
  height: 3rem;
  text-align: center;
  color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #2d8efc;
  position: relative;
  font-size: 1.1rem;

  .popup-back {
    position: absolute;
    left: 20px;
    top: 1rem;
  }
}

/deep/ .van-grid-item__content {
  padding: 0 0 !important;
}

/deep/ .van-search {
  padding: 10px 0;
}

/deep/ .van-search__action {
  line-height: 0;
}

/deep/ .van-search__content {
  background-color: #f5f5f5;
}
</style>
